import CommonService from '../../../../../services/commonService';
import React from 'react';

function MouseOver(props) {
  return (
    <div
      className={'seat-mousover mouseover-popups font9 nowrap ' + props.seatMouseOverClass}
      style={{
        position: 'fixed',
        left: props.mouseOverPos ? props.mouseOverPos.x : null,
        top: props.mouseOverPos ? props.mouseOverPos.y : null,
      }}
    >
      <div>
        {props.t('CANCEL_TICKET.SEAT_NUMBER')}: {props.seat ? props.seat.object.number : null}
      </div>
      <div>
        {props.t('CANCEL_TICKET.FARE')}: CLP{' '}
        {props.seat ? CommonService.currency(props.seat.object.net_amount).split(',')[0] : null}
      </div>
      <div>
        {props.t('RESULTS_PAGE.SEAT_TYPE')}:{' '}
        {props.seat ? CommonService.capitalize(props.getSeatName(props.seat.object.type)) : null}
      </div>
      <span className="primary-triangle"></span>
    </div>
  );
}

export default MouseOver;



// WEBPACK FOOTER //
// ./src/features/Pasajebus/PasajebusServiceList/TrainCoachLayout/components/MouseOver.js